import React from 'react';
import { Icons } from '../../../assets/icons';
import TitleValueIcon from '../components/titleValueIcon';
import { classNames } from 'primereact/utils';
import { ProgressSpinner } from 'primereact/progressspinner';
import TitleValue from '../components/TitleValue';
import useTenantStore, { selectTenantId } from '../../../stores/TenantStore';
import OpenAPI from '../../../endpoint/Openapi';
import { noop } from '../../../utils/GeneralUtils';
import { type paths } from '../../../endpoint/Schema';

interface IPermissionsProps {
  userId: string;
}

const Permissions: React.FC<IPermissionsProps> = ({ userId }) => {
  const tenantId = useTenantStore(selectTenantId);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] =
    React.useState<
      paths['/api/v2/admin/users/{userId}/permissions']['get']['responses']['200']['content']['application/json']
    >();

  React.useEffect(() => {
    const getTrips = async () => {
      setLoading(true);

      try {
        const res = await OpenAPI.GET(
          '/api/v2/admin/users/{userId}/permissions',
          {
            params: {
              path: { userId },
              query: {
                tenantId,
              },
            },
          },
        );

        setData(res.data);
      } catch {}

      setLoading(false);
    };

    getTrips().catch(noop);
  }, [tenantId, userId]);

  function renderPermissionItem(title: string, value: string, icon: string) {
    return (
      <div
        className={classNames(
          'permissionRow',
          'rounded-md mb-4 inline-block w-full',
        )}
      >
        <TitleValueIcon
          containerClassName="flex flex-row w-full justify-between"
          valueClassName={
            value === 'Ok'
              ? 'okValue'
              : value === 'Issue'
                ? 'issueValue'
                : undefined
          }
          icon={icon}
          title={title}
          value={value}
        />
      </div>
    );
  }

  if (loading) {
    return (
      <ProgressSpinner
        style={{
          width: '40px',
          height: '40px',
          alignSelf: 'center',
        }}
      />
    );
  }

  const permissionsList = [
    {
      title: 'GPS Permission Granted',
      value: data?.gpsPermissionGranted,
      icon: Icons.ic_permission_gps,
    },
    {
      title: 'Motion Activity Permission Granted Android',
      value: data?.motionActivityPermissionGrantedAndroid,
      icon: Icons.ic_permission_motion,
    },
    {
      title: 'Low Precise Location Ios',
      value: data?.lowPreciseLocationIos,
      icon: Icons.ic_permission_precise,
    },
    {
      title: 'Device Has Been Rooted Android',
      value: data?.deviceHasBeenRootedAndroid,
      icon: Icons.ic_permission_rooted_android,
    },
    {
      title: 'Low Power Mode',
      value: data?.lowPowerMode,
      icon: Icons.ic_permission_low_power,
    },
    {
      title: 'Motion Fitness Permission Granted Ios',
      value: data?.motionFitnessPermissionGrantedIos,
      icon: Icons.ic_permission_fitness,
    },
    {
      title: 'Jailbreak Ios',
      value: data?.jailbreakIos,
      icon: Icons.ic_permission_jailbreak,
    },
  ];

  return (
    <div>
      <div
        className="columns-2 py-4 rounded-md mb-6 mt-4"
        style={{ backgroundColor: 'var(--surface-b)' }}
      >
        <TitleValue
          containerClassName="py-4 px-4"
          title="deviceModel"
          value={data?.deviceModel ?? ''}
        />
        <TitleValue
          containerClassName=" px-4"
          title="Application:"
          value={data?.application ?? ''}
        />
        <TitleValue
          containerClassName="py-4 px-4"
          title="DeviceOsVersion:"
          value={data?.deviceOsVersion ?? ''}
        />
        <TitleValue
          containerClassName=" px-4"
          title="sdkVersion:"
          value={data?.sdkVersion ?? ''}
        />
      </div>
      <div className="w-full columns-2">
        {permissionsList.map((item) =>
          renderPermissionItem(item.title, item.value ?? '', item.icon),
        )}
      </div>
    </div>
  );
};

export default Permissions;
